<script>
  import options from './FundraisingQrCodeOverlay.options'
  export default options
</script>

<template>

  <div class="kb-overlay-styles__content-wrapper">

    <article class="kb-overlay-styles kb-fundraising-qr-code-overlay">

      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <div class="kb-overlay-styles__hero">
          <div class="kb-overlay-styles__hero-wrapper">
            <h2 class="kb-overlay-styles__hero-title">{{ getLabel('title') }}</h2>
          </div>
        </div>
        
        <div class="kb-overlay-styles__hero-curve">

          <div class="kb-fundraising-qr-code-overlay__hero-curve-color-wrapper">
            <div class="kb-fundraising-qr-code-overlay__hero-curve-color-filler"></div>
  
            <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
            </svg>
          </div>

          <div class="kb-fundraising-qr-code-overlay__QR-img">
            <img :src="`data:image/png;base64, ${qrImgUrlBase}`" :alt='getLabel("imgBase64Alt")' />
          </div>

        </div>
        

        <div class="kb-overlay-styles__form-content kb-stafet-donation-flow">

          <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">

            <div class="kb-stafet-step__texts-wrapper">

              <p class="kb-stafet-step__texts-description" v-html="getLabel('description')"></p>

              <a v-if="qrPrintPageLink" class="kb-link" :href="qrPrintPageLink" :target="qrPrintPageLinkTarget" > {{ getLabel("printQrLinkText") }} </a>

            </div>

          </section>

        </div>

      </div>

    </article>

  </div>
</template>
